const ValidationContent = {
	meta: "Validation",
	title: "Testing the new designs",
	paras: [
		"Through the course of progressively improving the search user-flow, many learnings and insights were made.",
		"The search result cards were the smallest component, so we tested many iterations on this. Some changes had no effect on conversion rates, but mostly online bookings and sales enquiries were improved.",
		"The search template was more complex, with many inter-dependent components. Overall, users tended to prefer having optional ways of refining a search. For this reason a search form was displayed along with the multi-select facet filters.",
	],
	img01alt: "Lab testing room",
	img01caption: "Qualitative lab-testing of the new search template design",
	quote: {
		statement: "The first thing I can see is prices... I like that",
		personna: "Leo, 34 - 'New to cruise'",
	},
};

export default ValidationContent;
